module.exports = __webpack_public_path__ + "1737db0d05e939b2023b5c657aca9242.svg";